'use es6';

export var getRecaptchaWidgetId = function getRecaptchaWidgetId(state) {
  return state.recaptcha.widgetId;
};
export var getRecaptchaToken = function getRecaptchaToken(state) {
  return state.recaptcha.token;
};